import i18next, { i18n } from 'i18next';
import { getItem } from './localStorage';
import { LangCodeEnum } from '../../gql/graphql';

export enum MENUSTYLE {
    WIDE = 'WIDE',
    NARROW = 'NARROW',
    AUTO = 'AUTO'
}

export const MENUSETTINGSTRING = 'SETTIING_MENU_STYLE';
export const LANGSETTINGSTRING = 'SETTIING_LANGUAGE';

export const getMenuStyle = (): MENUSTYLE => {
    let initValue = getItem(MENUSETTINGSTRING);
    return initValue ? (initValue as MENUSTYLE) : MENUSTYLE.WIDE;
};

export const getLanguage = (): LangCodeEnum => {
    let localStorageLanguageSetting: string | null = getItem(LANGSETTINGSTRING); //String in all caps: EN, SV, FI
    if (localStorageLanguageSetting) {
        let LangCodeEnumKey =
            localStorageLanguageSetting.toLowerCase().charAt(0).toUpperCase() +
            localStorageLanguageSetting.slice(1).toLowerCase();
        let langCodeEnumValue: LangCodeEnum =
            LangCodeEnum[LangCodeEnumKey as keyof typeof LangCodeEnum];
        return langCodeEnumValue;
    } else {
        let LangCodeEnumKey =
            i18next.language.toLowerCase().charAt(0).toUpperCase() +
            i18next.language.slice(1).toLowerCase();
        let langCodeEnumValue: LangCodeEnum =
            LangCodeEnum[LangCodeEnumKey as keyof typeof LangCodeEnum];
        return langCodeEnumValue;
    }
};
